import { styled } from 'styled-components';

import ButtonIconCommon from '../ButtonIcon';

export const ButtonIcon = styled(ButtonIconCommon)`
  display: flex;
  justify-content: center;

  & svg {
    transform: rotate(180deg);
  }
`;
